/*
 * @Description: 
 * @Autor: pangting
 * @Date: 2020-12-10 11:51:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-30 15:18:11
 */
import { SysConfigBaseApi } from "./SysConfigBaseApi";
import { Methods } from '@newview/infrastructure'; 
/**
 * 项目工程划分类别数据操作
 */
export class UserinforApi extends SysConfigBaseApi {
    public get ControllerName(): any {
        return 'Userinfor'
    }
    //#region location
    /**  保存用户 */
  public saveUser (formData: any) {
    return this.send(formData, 'SaveUser', Methods.POST)
  }
  /**
   * 简单系统用户账户创建方法
   * @param fromData 
   * @returns 
   */
  public SaveSystemUser(fromData:any){
    return this.send(fromData, 'SaveSystemUser', Methods.POST)
  }
  /**
   * 注销用户（假删除）
   * @param UId 
   * @returns 
   */
  public DisposeSystemUser(UId:number){
    return this.send({UId},'DisposeSystemUser', Methods.GET)
  }
  /**
   *  删除用户
   */
  public deleteUser (userId) {
    return this.send([{ Id: userId, Status: 4 }], 'Saves', Methods.POST)
  }
  /**
   * 获取机构下的用户
   * @param insId
   */
  public getUserInforsByInsId (insId) {
    return this.send({ filter: ` DId = ${insId} and Status != 4 ` }, 'GetEntities', Methods.GET)
  }
  /**
   * 获取导出用户数据
   */
  public exportUserData () {
    return this.send({}, 'ExportUserData', Methods.GET)
  } 
  /**
   * 修改密码
   */
  public updateUserPassword (Parameters) {
    return this.send(Parameters, 'UpdateUserPassword', Methods.POST)
  }
   /**
   * 根据用户Id获取角色及子系统
   * @param insId
   */
  public GetRoleAndSubSys (UserId) {
    return this.send({ UserId: UserId }, 'GetRoleAndSubSys', Methods.GET)
  }
  /**
   * 获取当前用户当前机构角色信息
   * @param UserId 
   * @param BIId 
   * @returns 
   */
  public NewGetRoleAndSubSys (UserId,BIId) {
    return this.send({ UserId,BIId }, 'NewGetRoleAndSubSys', Methods.GET)
  }
  /**
   * @description: 根据人员Id、子系统Id获取人员机构Id
   * @param {*} userId
   * @param {*} systemId
   * @param {*} projectId
   * @return {*}
   * @author: pangting
   */
  public GetBIIdByUserId (userId,systemId,projectId) {
    return this.send({userId:userId,systemId:systemId,projectId:projectId}, 'GetBIIdByUserId', Methods.GET)
  } 
  /**
   * 重置密码  /api/v1/Userinfor/ResetAccountPwd
   */
  public resetPasswordNew (params) {
    return this.send(params, 'ResetPassword', Methods.POST)
  }
  /**
   * 重置密码
   */
  public resetPassword (Id,newPwd) {
    return this.send({ userId: Id ,newPwd:newPwd}, 'ResetPassword', Methods.GET) 
  }
  public ResetAccountPwd(AId)
  {
    return this.send({AId}, 'ResetAccountPwd', Methods.GET)
  }

  /**
   * 申请影子服务
   * @param account 
   * @returns 
   */
  public ApplyUserShadow(account:string){
    return this.send({aact:account}, 'ApplyUserShadow', Methods.POST) 
  }
  /** 
   * @param skey 用户账户幻影
   * @returns 
   */
  public ShadowServiceForGhostUser(skey:string){
    return this.send({key:skey}, 'ShadowServiceForGhostUser', Methods.POST) 
  }
  /**
   * 获取BIId下用户信息
   * @param pageIndex  
   * @param pageSize 
   * @param BIId 
   * @param Status
   * @returns 
   */
  public GetBIIDUserInforPageData(pageIndex:number,pageSize:any,BIId:number,Status:number=1) {
    return this.send({pageIndex,pageSize,BIId,Status}, 'GetBIIDUserInforPageData', Methods.GET)
  }

    /**
   * 获取BIId下用户信息（管理）
   * @param pageIndex  
   * @param pageSize 
   * @param BIId 
   * @param Status
   * @returns 
   */
     public GetBIIDUserInforPageDataAdmin(pageIndex:number,pageSize:any,BIId:number,Status:number=1) {
      return this.send({pageIndex,pageSize,BIId,Status}, 'GetBIIDUserInforPageDataAdmin', Methods.GET)
    }

  /**
   * @description: 签字/盖章
   * @param {*} userId 用户Id
   * @param {*} sealType 类型（1:签字  2：盖章）
   * @param {*} password 证书密码
   * @param {*} source 认证原文
   * @return {*}
   * @author: pangting
   */  
  public SignHBCA(userId,sealType,password,source){
    // return this.send({userId:userId,sealType:sealType,password:password,source:source}, 'SignHBCA', Methods.POST)
    return this.send({}, 'SignHBCA?userId='+userId+"&sealType="+sealType+"&password="+password+"&source="+source, Methods.POST)
  }
}